import { objectsRHandler } from '@/utils/objectsRHandler';
import Tournament from '../list/tournament/index';
import TournamentStage from '../list/tournament/stage';
import TournamentStageGroup from '../list/tournament/group';

const API_PATH = 'tournaments';
const API_PATH_STAGES = 'tournament-stages';
const API_PATH_GROUPS = 'tournament-stage-groups';

export const TournamentManager = {
  objects: objectsRHandler(API_PATH, Tournament),
  stages: objectsRHandler(API_PATH_STAGES, TournamentStage),
  groups: objectsRHandler(API_PATH_GROUPS, TournamentStageGroup),
};
